/**
 * @file Custom print address selection modal.
 */

import PropTypes from 'prop-types';

import withModal from '../../../modal/withModal';
import CustomPrintAddressSelect from './CustomPrintAddressSelect';

const propTypes = {
  address: PropTypes.object,
  onAddressConfirm: PropTypes.func.isRequired,
  forceOpen: PropTypes.bool,
};

const CustomPrintAddressSelectModal = withModal(CustomPrintAddressSelect, {
  dismissible: false,
  hideHeader: true,
  size: 'xs',
});

CustomPrintAddressSelectModal.propTypes = propTypes;

export default CustomPrintAddressSelectModal;
